
export default function formPosition(direction) {

  console.log("formPosition function. Direction = ",direction);

  /* the js for moving the forminto the users view
// approach this knwoing the following:

- I have to move it back after page change (or ensure we keep a copy of the HTML)
- I need to ensure JS remains working; i.e moving is better then "copying"


 - Review this functions - does it fully work
 - if not; fix it
 - if so - reply to wpmudev 
*/


if (direction == "in"){
console.log("direction = in");


let el = document.getElementById("placer-2533"),
     moveTo = document.getElementById("holder-2533"); // this would be the custom html gutenberblock
moveTo.parentNode.insertBefore(el, moveTo);

} else if (direction == "out"){
  console.log("direction = out");

  // as this function fires after page change, we need to check if the div is even in the barba container
  console.log(" move the item back out");


  let el = document.getElementById("placer-2533"),
      moveTo = document.getElementById("forminator-placer-position"); 
      moveTo.parentNode.insertBefore(el, moveTo);

}

} //export default function init()